angular.module('NaviaqWebApp').directive('activityLineTimeInterval', [function () {
    'use strict';

    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'app/report/directives/activity-line-time-interval.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
